import { ref } from "vue"

const isOpen = ref(false)
const answer = ref("")
const data = ref({
  message: "",
  inputLabel: "",
  inputPlaceholder: "",
  cancelLabel: "",
  confirmLabel: "",
  resolve: null as null | ((value: string|null) => void),
  reject: null as null | ((error: Error) => void),
})

function confirm() {
  if (data.value.resolve) {
    data.value.resolve(answer.value)
  }

  closePrompt()
}

function cancel() {
  if (data.value.resolve) {
    data.value.resolve(null)
  }

  closePrompt()
}

function closePrompt() {
  isOpen.value = false
  data.value.resolve = null
  data.value.reject = null
}

export interface PromptProps {
  message?: string
  defaultAnswer?: string
  inputLabel?: string
  inputPlaceholder?: string
  cancelLabel?: string
  confirmLabel?: string
}

export function usePrompt() {
  function prompt({ message = "", defaultAnswer = "", inputLabel = "", inputPlaceholder = "", cancelLabel = "Atcelt", confirmLabel = "Apstiprināt" }: PromptProps = {}) {
    if (data.value.reject) {
      data.value.reject(new Error("Another prompt has been created"))
    }

    return new Promise((resolve, reject) => {
      answer.value = defaultAnswer ?? ""
      data.value = {
        message, inputLabel, inputPlaceholder, cancelLabel, confirmLabel, resolve, reject
      }
      isOpen.value = true
    })
  }

  return {
    prompt,
    isOpen,
    answer,
    data,
    confirm,
    cancel,
  }
}
